import React, { useEffect, useState } from "react";
import { marketingCtaClicked } from "@utils/segment/marketingCtaClicked";
import { Builder } from "@builder.io/react";
import Footer from "@components/RedesignComponents/Footer/Footer";
import { FooterDataType } from "src/assets/Types/Redesign/FooterDataType.type";
import SPfetch from "@services/SPFetch.class";
import { navigate } from "gatsby";

const FooterWrapper: React.FC = () => {
  const [data, setData] = useState<FooterDataType | null>(null);

  useEffect(() => {
    (async () => {
      const data = await SPfetch.get(
        `https://cdn.builder.io/api/v3/content/footer?apiKey=${process.env.GATSBY_BUILDER_REBRAND_API_KEY}`
      );

      setData(data?.results?.[0]?.data);
    })();
  }, []);

  const onClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    // const isNewTab = e.currentTarget.target === "_blank";
    // marketingCtaClicked({
    //   text: e.currentTarget.text,
    //   url: window.location.pathname,
    //   target: e.currentTarget.href,
    // });
    // if (!isNewTab) {
    //   return window.open(e.currentTarget.href, "_blank");
    // }
    // navigate(e.currentTarget.href);
  };

  return data ? <Footer onClick={onClick} {...data} /> : <></>;
};

export default FooterWrapper;

export const RegisterFooter = () => {
  Builder.registerComponent(FooterWrapper, {
    name: "footer",
    inputs: [],
  });
};
